import { render, staticRenderFns } from "./TenantDetails.vue?vue&type=template&id=57e57bcb&scoped=true"
import script from "./TenantDetails.vue?vue&type=script&lang=js"
export * from "./TenantDetails.vue?vue&type=script&lang=js"
import style0 from "./TenantDetails.vue?vue&type=style&index=0&id=57e57bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e57bcb",
  null
  
)

export default component.exports